<div>
  <div  style="padding-bottom:  10px;">
    <h2>Билеты ПДД 2026 — выбирайте формат: по номеру, экзамен, тест или марафон | Подготовка онлайн</h2>
  </div>
  <div class="billets_bloks_list">
    <div class="controol_bilets_list" >
      <div class="el_controol error">
        Ошибки
      </div>
      <div class="el_controol save">
        Избранные
      </div>
      <div class="el_controol settigs" (click)="SettingsService.set_open_settings(true)">
        <div class="text">
          Настройки
        </div>
        <div>
          <i class="icon"></i>
        </div>
      </div>
    </div>
    <settings-component></settings-component>
    <a [routerLink]="['/','marathon']" class="billest_block">
      <div class="icon_e_block">
        🏅
      </div>
      <div>
        <div class="title">
          Решать в формате марафона
        </div>
        <div>
          Все 800 вопросов подряд
        </div>
        <div style="padding-top: 10px; display: flex;">
          <div style="display: flex; gap: 5px; justify-content: center; min-height: 30px; align-items: center; padding: 5px 10px; color: #fff; background: #0d69e1; border-radius: 6px;">
            <div>
              Перейти к марафону
            </div>
            <div>
              <i class="icon_to_page_billets"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
    <div>
      <div style="padding-bottom:  10px;">
        <b>Список всех белетов</b> для подготовки к экзамену ГИБДД
      </div>
      <div>
        <ul class="billets_list">
          <ng-container *ngFor="let billet of this.BilletsService.billets_list; let  i = index">
            <li class="billet">
              <a [routerLink]="['/','bilets','bilet-'+(i + 1)+'-'+(1)]">
                <div class="icon_billet_bg">
                  <i class="icon_billet"></i>
                </div>
                <div  class="number_billet">
                  Билет № <b>{{ i + 1 }}</b>
                </div>
                <div  class="number_billet_mobile">
                  <b>{{ i + 1 }}</b>
                </div>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <a [routerLink]="['/', 'bilets-themes']" class="billest_block">
      <div class="icon_e_block">
        📜
      </div>
      <div>
        <div class="title">
          Список тем для подготовки к экзамену
        </div>
        <div>
          Все экзаменационные вопросы разбиты по темам
        </div>
        <div style="padding-top: 10px; display: flex;">
          <div style="display: flex; gap: 5px; justify-content: center; min-height: 30px; align-items: center; padding: 5px 10px; color: #fff; background: #0d69e1; border-radius: 6px;">
            <div>
              Перейти к списку тем
            </div>
            <div>
              <i class="icon_to_page_billets"></i>
            </div>
          </div>
        </div>
      </div>
    </a>

    <a [routerLink]="['/','gibdd-ekzamen']" class="billest_block">
      <div class="icon_e_block">
        👮
      </div>
      <div>
        <div class="title">
          Решать в формате экзамена как в ГИБДД
        </div>
        <div>
          Вам выдаеться случайный билет, на его решение отводиться 20 мину, максимальное количество ошибок 4
        </div>
        <div>
          По итогам сдачи Вам могут быть назначены дополнительные 5 или 10 вопросов, а время на них составит 5 или 10 минут соответственно.
        </div>
        <div style="padding-top: 10px; display: flex;">
          <div style="display: flex; gap: 5px; justify-content: center; min-height: 30px; align-items: center; padding: 5px 10px; color: #fff; background: #0d69e1; border-radius: 6px;">
            <div>
              Перейти к полноценному экзамену
            </div>
            <div>
              <i class="icon_to_page_billets"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
    <a [routerLink]="['/','trenerovachnyy-ekzamen']" class="billest_block">
      <div class="icon_e_block">
        🎯
      </div>
      <div>
        <div class="title">
          Решать в формате тренировочного экзамена
        </div>
        <div>
          Вам выдаеться случайный билет, на его решение отводиться 20 мину
        </div>
        <div>
          Вовремя решения билета вам так-же будут доступны подсказки
        </div>
        <div style="padding-top: 10px; display: flex;">
          <div style="display: flex; gap: 5px; justify-content: center; min-height: 30px; align-items: center; padding: 5px 10px; color: #fff; background: #0d69e1; border-radius: 6px;">
            <div>
              Пройти тренеровочный экзамен
            </div>
            <div>
              <i class="icon_to_page_billets"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
